export enum Formats {
    Date = 'Date',
    Datetime = 'Datetime',
    SimNao = 'SimNao',
    Function = 'Function',
    SlideToggle = 'SlideToggle',
    ComboBox = 'ComboBox',
    Currency = 'Currency',
    MinuteToHour = 'MinuteToHour',
    CheckBox = 'CheckBox',
    Image = 'Image',
}

export enum ExcelFormats {
    Currency = 'Currency',
    MinuteToHour = 'MinuteToHour',
    Function = 'Function',
    SimNao = 'SimNao',
}

export class Option {
    key: string;
    value: number;
    selected: boolean = false;

    constructor(key, value) {
        this.key = key;
        this.value = value;
    }

    public display(self: Option): string {
        return self?.key;
    }

    get displayWith() {
        return this.key;
    }

}

export class Coluna {
    columnDef: string;
    header: string;
    footer: string = "";
    calculateFooter: boolean = false;
    style: any = "";
    maxChars: number = 9999;
    display: boolean = true;
    export: boolean = true;
    format: Formats;
    excelFormat: ExcelFormats;
    function: any;
    editable: boolean = false;
    options: Option[];
    onChange: any = (event, element) => { };
    onBlur: any = (event, element) => { };
    accessFunction: string;
    accessFunctionRequired: boolean = false;
    link: string;
    target: string;
    routerLink: string;
    routerLinkColumnDef: string;
    queryParams: any;

    constructor(object?) {
        var self = this;
        if (object) {
            Object.keys(object).forEach(function (k) {
                self[k] = object[k];
            });
        }
    }

}